import React, { Component } from "react";
import { connect } from "react-redux";

//Deps
import { withStyles } from "@material-ui/core/styles";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  Typography
} from "@material-ui/core";

//Images
import { demo1, demo2, demo3 } from "./../static/images";

function mapStateToProps(state) {
  return {
    state
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

//Styles
const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: "2em"
  },
  title: {
    justifyContent: "center",
    textAlign: "center"
  },
  card: {
    maxWidth: 345,
    height: 400
  },
  cardContent: {
    height: 250,
    overflow: "hidden"
  },
  cardAction: {
    justifyContent: "center"
  },
  media: {
    height: 0,
    paddingTop: "56.25%" // 16:9
  }
});

class ProductsPage extends Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Grid container spacing={24}>
          <Grid item xs>
            <Card className={classes.card}>
              <CardMedia
                className={classes.media}
                image={demo1}
                title="Contemplative Reptile"
              />
              <CardContent className={classes.cardContent}>
                <Typography gutterBottom variant="h6" className={classes.title}>
                  demo
                </Typography>
                <Typography component="p">
                  Meatloaf sirloin biltong, landjaeger salami porchetta tongue
                  leberkas burgdoggen spare ribs drumstick ground round brisket
                  ham buffalo. Alcatra cow turkey picanha.
                </Typography>
              </CardContent>
              <CardActions className={classes.cardAction}>
                <Button size="small" color="primary">
                  Free
                </Button>
                <Button size="small" color="primary">
                  Learn More
                </Button>
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs>
            <Card className={classes.card}>
              <CardMedia
                className={classes.media}
                image={demo2}
                title="Contemplative Reptile"
              />
              <CardContent className={classes.cardContent}>
                <Typography gutterBottom variant="h6" className={classes.title}>
                  standard
                </Typography>
                <Typography component="p">
                  Bacon ipsum dolor amet flank strip steak meatball porchetta,
                  salami porchetta tongue leberkas burgdoggen spare ribs
                  drumstick ground round brisket ham buffalo.
                </Typography>
              </CardContent>
              <CardActions className={classes.cardAction}>
                <Button size="small" color="primary">
                  Learn More
                </Button>
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs>
            <Card className={classes.card}>
              <CardMedia
                className={classes.media}
                image={demo3}
                title="Contemplative Reptile"
              />
              <CardContent className={classes.cardContent}>
                <Typography gutterBottom variant="h6" className={classes.title}>
                  executive
                </Typography>
                <Typography component="p">
                  Sirloin filet mignon shoulder, ribeye buffalo tongue chicken
                  shankle picanha corned beef pork belly turkey. Alcatra cow
                  turkey picanha tail sirloin buffalo shankle meatball.
                </Typography>
              </CardContent>
              <CardActions className={classes.cardAction}>
                <Button size="small" color="primary">
                  Learn More
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ProductsPage));



// WEBPACK FOOTER //
// ./src/pages/ProductsPage.js